import moment from 'moment';
import { ISerializable } from './base';
import { BoxType, Shipping, Variant, Box } from './box';
import { Subcategory } from './category';
import { Price } from './price';

export class CustomerBox implements ISerializable<CustomerBox> {
  name: string | undefined;
  containerName: string | undefined;
  type: string | undefined;
  boxType: BoxType | undefined;
  boardType: string | undefined;
  boardStrength: string | undefined;
  kraftType: string | undefined;
  secondaryKraftType: string | undefined;
  subcategory: Subcategory | undefined;
  price: Price | undefined;

  preset: boolean | undefined;
  gloss: boolean | undefined;
  luxe: boolean | undefined;
  twoSided: boolean | undefined;
  insideOnly: boolean | undefined;
  noPrint: boolean | undefined;
  options: string | undefined;

  length: number | undefined;
  width: number | undefined;
  depth: number | undefined;

  blankLength: number | undefined;
  blankWidth: number | undefined;

  pieceNumber: number | undefined;
  totalPieces: number | undefined;
  quantity: number | undefined;

  rush: boolean | undefined;

  deserialize(input: any): CustomerBox {
    this.name = input.name;
    this.containerName = input.containerName;
    this.type = input.type;
    if (input.BoxType) {
      this.boxType = new BoxType().deserialize(input.BoxType);
    }
    if (input.boardStrength) {
      this.boardStrength = input.boardStrength.strength;
    }
    this.boardType = input.boardType;
    this.kraftType = input.kraftType;
    this.secondaryKraftType = input.secondaryKraftType;
    this.subcategory = input.subcategory;
    this.price = input.price;
    this.preset = input.preset;

    this.gloss = input.gloss;
    this.luxe = input.luxe;
    this.twoSided = input.twoSided;
    this.insideOnly = input.insideOnly;
    this.options = input.options;

    this.length = input.length;
    this.width = input.width;
    this.depth = input.depth;

    this.quantity = input.quantity;
    this.pieceNumber = input.pieceNumber;
    this.totalPieces = input.totalPieces;

    this.blankLength = input.blankLength;
    this.blankWidth = input.blankWidth;

    this.rush = input.rush;

    return this;
  }
}
export class LineItemVariant implements ISerializable<LineItemVariant> {
    id: string | undefined;
    title: string | undefined;
    price: number | undefined;
    product: Product | undefined;
    weight: number | undefined;

    deserialize(input: any): LineItemVariant {
        this.id = input.id;
        this.title = input.title;
        this.price = input.price;
        if (input.product) {
            this.product = new Product().deserialize(input.product);
        }
        this.weight = input.weight;
        return this;
    }
}
export class CheckoutLineItem implements ISerializable<CheckoutLineItem> {

    id: string | undefined;
    title: string | undefined;
    quantity: number | undefined;
    variant: LineItemVariant | undefined;
    total: number | undefined;
    box: CustomerBox | undefined;
    price: Price | undefined;
    type: BoxType | undefined;
    preset: boolean | undefined;
    shipping: Shipping | undefined;
    containerName: string | undefined;
    rushOrder: boolean | undefined;

    deserialize(input: any): CheckoutLineItem {
        this.id = input.id;
        this.title = input.title;
        this.quantity = input.quantity;
        if (input.variant) {
            this.variant = new LineItemVariant().deserialize(input.variant);
        }
        this.total = input.total;
        if (input.box) {
            this.box = new CustomerBox().deserialize(input.box);
        }
        if (input.type) {
            this.type = new BoxType().deserialize(input.type);
        }
        this.preset = input.preset;
        // if (input.dimensions) {
        //     this.dimensions = new Dimensions().deserialize(input.dimensions);
        // }
        if (input.shipping) {
            this.shipping = new Shipping().deserialize(input.shipping);
        }
        this.containerName = input.containerName;
        this.rushOrder = input.rushOrder;
        this.price = input.price;

        return this;
    }
}
export class Product implements ISerializable<Product> {

    id: string | undefined;
    title: string | undefined;
    handle: string | undefined;

    createdAt: Date | undefined;
    updatedAt: Date | undefined;

    publishedScope: string | undefined;
    BoxType: string | undefined;
    published: boolean | undefined;

    // tags: string[];
    // images: Image[];

    variants: Variant[] = [];
    box: Box | undefined;

    deserialize(input: any): Product {

        this.id = input.id;
        this.title = input.title;
        this.handle = input.handle;
        if (input.created_at) {
            this.createdAt = moment(input.created_at).toDate();
        }
        if (input.updated_at) {
            this.updatedAt = moment(input.updated_at).toDate();
        }
        if (input.box) {
            this.box = new Box().deserialize(input.box);
        }
        this.publishedScope = input.published_scope;
        this.BoxType = input.product_type;
        this.published = input.published;
        this.variants = [];
        if (input.variants) {
            (input.variants as any[]).forEach((variant) => {
                this.variants.push(new Variant().deserialize(variant));
            });
        }

        return this;
    }
}

